export const namespaced = true

export const state = {
  sidebarActiveMenuIndex: null,
  sidebarActive: localStorage.getItem('sidebarOpened') ? Boolean(Number(localStorage.getItem('sidebarOpened'))) : true,
  sidebarArrowItem: false
}
export const mutations = {
  SET_ACTIVE_MENU_INDEX(state, index) {
    state.sidebarActiveMenuIndex = index
  },
  SET_SIDEBAR_COLLAPSE_STATE(state, parameters) {
    state.sidebarActive = parameters
  },
  SET_SIDEBAR_ACTIVE(state, value) {
    state.sidebarArrowItem = value
  },
  CLEAR_ACTIVE_INDEXES(state) {
    state.sidebarActiveMenuIndex = null
  }
}
export const getters = {
  sidebarArrowItem(state) {
    return state.sidebarOpen
  },
  sidebarActiveMenuIndex(state) {
    return state.sidebarActiveMenuIndex
  },
  sidebarActive(state) {
    return state.sidebarActive
  }
}
